import * as Cookies from 'js-cookie/src/js.cookie.js';
import { Injectable } from '@angular/core';
import { Currency } from 'app/model/currency.model';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { ActHttpService } from '../act-http/act-http.service';
import { Response } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '../app-config/app-config.service';
import { domain } from 'environments/properties';
import { DefaultValue } from 'app/model/constant';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class CurrencyService {

  private currency: Currency;
  private currencyList = new BehaviorSubject<Currency[]>([]);
  private currencySubject = new Subject<any>();
  private isB2C = false;
  private fetchedCurrencyList = false;

  private currencySubscribe: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private actHttp: ActHttpService,
    private appConfigService: AppConfigService,
    private authenticationService: AuthenticationService,
  ) {
    this.isB2C = this.authenticationService.isB2CClient();
    const defaultCurrency = DefaultValue.CURRENCY.currencyCode
    const currencyParam = this.activatedRoute.snapshot.queryParamMap.get('currency');
    const currencyCookies = this.getCurrencyFromCookie();
    if (currencyParam && currencyParam != defaultCurrency || ((currencyCookies && currencyCookies != defaultCurrency) && currencyParam != defaultCurrency)) {
      this.fetchCurrencyList();
    } else {
      this._setCurrency(DefaultValue.CURRENCY);
    }
  }

  setCurrency(use: string) {
    let currency = this.currencyList.value.find(c => c.currencyCode === use);
    if (!currency) {
      currency = DefaultValue.CURRENCY;
    }
    this._setCurrency(currency);
  }

  private _setCurrency(use: Currency) {
    if (this.currency !== use) {
      this.appConfigService.insertParam('currency', use.currencyCode);
      Cookies.set(AppConfigService.currencyCookieName, use.currencyCode, { domain: domain });
      this.currency = use;
      this.currencySubject.next(use);
    }
  }

  getCurrency(): Currency {
    if (this.currency) {
      return this.currency;
    }

    const currencyCookie = this.getCurrencyFromCookie();
    let currency = this.currencyList.value.find(c => c.currencyCode === currencyCookie);
    if (!currency) {
      const currencyParam = this.activatedRoute.snapshot.queryParams['currency'];
      currency = this.currencyList.value.find(c => c.currencyCode === currencyParam);
      if (!currency) {
        currency = DefaultValue.CURRENCY;
      }
    }
    return currency;
  }

  getCurrencyCode() {
    return this.currency && this.currency.currencyCode;
  }

  getCurrencyFromCookie(): string {
    return Cookies.get(AppConfigService.currencyCookieName);
  }

  getCurrencyObs(): Observable<any> {
    return this.currencySubject.asObservable();
  }

  private fetchCurrencyList() {
    if (this.isB2C) {
      this.currencySubscribe && this.currencySubscribe.unsubscribe();
      this.currencySubscribe = this._getCurrencyList().subscribe((res) => {
        if (res) {
          const currencyList = res;
          this.currencyList.next(currencyList);
          this._setCurrency(this.getCurrency());
        }
      }, (err) => {
        this.currencyList.next([DefaultValue.CURRENCY]);
        this._setCurrency(this.getCurrency());
      });
    } else {
      this.currencyList.next([DefaultValue.CURRENCY]);
      this._setCurrency(this.getCurrency());
    }
    this.fetchedCurrencyList = true;
  }

  private _getCurrencyList(): Observable<Currency[]> {
    const url = `${environment.endpoint.getCurrencies}`;
    return this.actHttp.rawGet(url)
      .map((res: Response) => res.json().data);
  }

  public getCurrencyList() {
    if (!this.fetchedCurrencyList) {
      this.fetchCurrencyList();
    }
    return this.currencyList.asObservable();
  }

  public transformCurrentCurrencyFromTHB(amount: number, ceiling: boolean = true) {
    if (ceiling) {
      return Math.ceil(amount / this.getCurrency().exchangeRate);
    }
    return amount / this.getCurrency().exchangeRate;
  }

  public transformCurrentCurrencyToTHB(amount: number, ceiling: boolean = true) {
    if (ceiling) {
      return Math.ceil(amount * this.getCurrency().exchangeRate);
    }
    return amount * this.getCurrency().exchangeRate;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/currency/currency.service.ts